import type { CSSProperties, ReactNode } from 'react';
import { cn } from '../../lib/cn';
import styles from './Alert.module.css';

export type AlertVariant = 'info' | 'error' | 'warning';

export type AlertProps = {
  variant?: AlertVariant;
  title?: string;
  children?: ReactNode;
  className?: string;
  style?: CSSProperties;
};

export function Alert({ variant = 'info', title, children, className, style }: AlertProps) {
  return (
    <div className={cn(styles.root, styles[`variant_${variant}`], className)} style={style} role="alert">
      {title ? <div className={styles.title}>{title}</div> : null}
      {children ? <div className={styles.body}>{children}</div> : null}
    </div>
  );
}
